import { ReactNode } from 'react'
import { useNavigate } from 'react-router'

import { Launch } from '@mui/icons-material'

import { ActionMenuItem } from '../ActionMenuItem/ActionMenuItem'
import { useActionMenuContext } from '../context/ActionMenuContext'
import { MenuItemLike } from '../index.types'

type Props<Data extends Record<string, unknown>> = MenuItemLike & {
  redirectTo: string | ((row: Data) => string)
  isDisabled?: (row: Data) => boolean
  text: string
  disabledMessage?: ReactNode
}

export const ActionRedirectItem = <Data extends Record<string, unknown>>({
  redirectTo,
  text,
  isDisabled,
  disabledMessage,
  displaySeparately = false
}: Props<Data>) => {
  const { row } = useActionMenuContext<Data>()
  const disabled = isDisabled?.(row) ?? false
  const navigate = useNavigate()

  const redirectLocation = disabled
    ? '#'
    : typeof redirectTo === 'function'
      ? redirectTo(row)
      : redirectTo

  const handleRedirect = () => {
    if (!disabled) {
      navigate(redirectLocation)
    }
  }

  return (
    <ActionMenuItem
      icon={<Launch />}
      text={text}
      disabled={disabled}
      displaySeparately={displaySeparately}
      tooltip={{ show: disabled, content: disabledMessage }}
      onClick={handleRedirect}
    />
  )
}
